import styled from 'styled-components'

export default styled.header`
  align-items: center;
  background: url(./images/background-header.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  padding: 6em 0;
`



// WEBPACK FOOTER //
// ./src/components/Header.js